import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data'
import SelectedAttachableRiderTable from '../../../create-proposal/steps/fourth-step/review-proposal/selected-attachable-rider-table'
import ClientInputForBorrowers from '../../../create-proposal/steps/second-step/age-borrowers/client-input-for-borrowers'
import { useMediaQuery } from '../../../../../hooks/common/use-media-query'
import LevelRanking from '../../../create-proposal/steps/fourth-step/review-proposal/level-ranking'
import UniformCoverage from '../../../create-proposal/steps/fourth-step/review-proposal/uniform-coverage'
import SalaryRank from '../../../create-proposal/steps/fourth-step/review-proposal/salary-rank'
import ClientSupportingDocuments from '../../../create-proposal/steps/third-step/client-supporting-documents'
import ChannelTypeReview from '../../../create-proposal/steps/fourth-step/review-proposal/channel-type-review'
import BasicInfoReview from '../../../create-proposal/steps/fourth-step/review-proposal/basic-info-review'
import Selection from '../../../create-proposal/steps/fourth-step/review-proposal/selection'
import ViewSection from '../../../../ui/view-section'
import LoadingFile from '../../../../ui/loading-file'
import { useFilesActions } from '../../../../../hooks/actions/use-files-actions'

export default function ProposalPreview() {
    
    const { 
        isShowPaymentTermAndLoanMaturity, 
        isPrototype, 
        isCustomize, 
        isAmountOfLoansSelected, 
        isCoverageTypeSelected, 
        isLevelRanking, 
        isUniformCoverage, 
        isSalaryRank,
        isProductGCLI,
        isLevelRankingAndSalaryRank,
        isProductGPA, 
        isProductGYRT, 
        isProductGCI,
        basicInformation,
        affiliation,
        natureOfBusinessItem,
        companyContactNumber,
        contactPersonNumber,
        groupClassification,
        othersGroupClassificationValue,
        hasOtherSpecifyGC,
        typeOfGroup,
        othersTypeOfGroupValue,
        typeOfGroupSubType,
        hasSubTypeToG,
        ageProfileFormat,
        coverage,
        amountOfLoans,
        notesCFE,
        commission,
        services,
        maturityMonthsFormat,
        fAmountPortfolio,
        formatMinMaxAmount,
        paymentTerm,
        // paymentTermState,
        modeOfPayment,
        proposalTypeState,
        prototype,
        product,
        basicPlan,
        channelType,
        showInputChannelType,
        channelTypeSubName,
        channelTypeNumber,
        channelTypeEmail,
        proposalAs,
        isForRenew,
        registeredNameForRenew,
        inputsByLevelRanking,
        inputsByUniformCoverage,
        inputsBySalaryRank,
        riders,
        ridersBMSR,
        ridersAmountOfLoans,
        ridersUniformCoverage,
        ridersSalaryRank,
        ridersLevelRanking,
        borrowerAgeOptionsList,
        filesCFE,
        minAgeProfile,
        maxAgeProfile,
    } = useProposalTypeData();
    const { 
        isLoadingDownloadMasterAttachedFile, 
        handleDownloadSupportingDocumentsCFE: handleDownloadFileCFE 
    } = useFilesActions()
    const isPreview: boolean = true;
    const isDesktop = useMediaQuery("(min-width: 1024px)");

    return (
        <>
            <div className="grid grid-cols-1 gap-3.5 ">
                <ViewSection
                    title="Channel & Proposal"
                    description="Review the selected channel and proposal details."
                >
                    <ChannelTypeReview
                        selectChannelType={channelType}
                        showInput={showInputChannelType}
                        selectProposalAs={proposalAs?.name}
                        sECRegisteredNameRenew={registeredNameForRenew}
                        isRenew={isForRenew}
                        channelSubName={channelTypeSubName}
                        channelSubNumber={channelTypeNumber}
                        channelSubEmail={channelTypeEmail}
                    />
                </ViewSection>
                <ViewSection
                    title="Client Information"
                    description="Review the client's company and contact information."
                >
                    <BasicInfoReview 
                        info={basicInformation} 
                        affiliations={affiliation}
                        natureOfBusinessItem={natureOfBusinessItem?.name}
                        companyContactNumberName={companyContactNumber?.name}
                        companyContactNumberType={companyContactNumber?.id}
                        contactPersonContactName={contactPersonNumber?.name}
                        contactPersonContactType={contactPersonNumber?.id}
                    />
                </ViewSection>
                <ViewSection
                    title="Group Profile & Payment Details"
                    description="Review the selected group classification, group type, age profile, and payment arrangement for this proposal."
                >
                    <div className='grid lg:grid-cols-4 gap-2'>
                        <Selection
                            labelTitle='Group Classification'
                            labelName={groupClassification?.name ?? ''}
                            hasOtherSpecify={hasOtherSpecifyGC}
                            otherSpecifyValue={othersGroupClassificationValue ?? ''}
                        />
                        <Selection
                            labelTitle='Type of Group'
                            labelName={typeOfGroup?.name ?? ''}
                            hasOtherSpecify={!!othersTypeOfGroupValue}
                            otherSpecifyValue={othersTypeOfGroupValue ?? ''}
                            hasSubType={hasSubTypeToG}
                            sabTypeData={typeOfGroupSubType}
                        />
                        <Selection
                            labelTitle='Age Profile'
                            isHasCheckbox={true}
                            labelName={ageProfileFormat}
                        />
                        <Selection
                            labelTitle='Mode of Payment'
                            labelName={modeOfPayment?.name ?? ''}                    
                        />
                    </div>
                </ViewSection>
                <ViewSection
                    title="Proposal Configuration & Loan Details"
                    description="Review the proposal type, product and coverage configuration, loan details, payment terms, applicable charges, and required master list file."
                >
                    <div className="grid grid-cols-1 gap-x-6 gap-y-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                        <Selection
                            labelTitle={`${!proposalTypeState?.name ? '-' : 'Type of Proposal'}`}
                            labelName={proposalTypeState?.name ?? ''}                    
                        />
                        {isPrototype && (
                            <Selection
                                labelTitle='Type of Prototype'
                                labelName={prototype?.name ?? ''}                 
                            />
                        )}
                        {isCustomize && (
                            <>
                                <Selection
                                    labelTitle="Type of Product"
                                    labelName={product?.name ?? ""}
                                />
                                <Selection
                                    labelTitle="Basic Plans"
                                    labelName={basicPlan?.name ?? ""}
                                />
                                {/* Coverage */}
                                {isCoverageTypeSelected && (
                                    <Selection
                                        labelTitle="Coverage Type"
                                        labelName={coverage?.name ?? ""}
                                    />
                                )}
                                {/* Amount of Loans */}
                                {isAmountOfLoansSelected && (
                                    <>
                                        <Selection
                                            labelTitle="Amount of Loans"
                                            labelName={amountOfLoans?.name ?? ""}
                                        />
                                        <Selection
                                            labelTitle="Minimum & Maximum Loan Amount"
                                            labelName={formatMinMaxAmount}
                                        />
                                        <Selection
                                            labelTitle="Loan Portfolio"
                                            labelName={fAmountPortfolio}
                                        />
                                    </>
                                )}
                                {/* Payment Term */}
                                {isShowPaymentTermAndLoanMaturity && (
                                    <>
                                        <Selection
                                            labelTitle="Payment Term"
                                            labelName={paymentTerm?.name ?? ""}
                                        />
                                        <Selection
                                            labelTitle="Loan Maturity"
                                            labelName={`${maturityMonthsFormat} months`}
                                        />
                                    </>
                                )}
                                {/* Commission */}
                                <Selection
                                    labelTitle="Commission Rate"
                                    labelName={`${commission ?? 0}%`}
                                />
                                {/* Service Fee */}
                                <Selection
                                    labelTitle="Service/Collection Fee"
                                    labelName={`${services ?? 0}%`}
                                />
                            </>
                        )}
                    </div>
                </ViewSection>
                {/* COVERAGE DETAILS */}
                {isCustomize && isCoverageTypeSelected && (
                    <ViewSection
                        title="Coverage Configuration"
                        description="Review how the coverage is structured and applied based on the selected coverage type."
                    >
                        <div className="overflow-hidden rounded-lg border border-gray-200">
                            {isLevelRanking && (
                                <LevelRanking
                                    inputsByLevelRanking={inputsByLevelRanking}
                                    selectedCoverageTypeState={coverage?.name}
                                    isPreview={isPreview} 
                                />
                            )}
                            {isUniformCoverage && (
                                <UniformCoverage 
                                    inputsByUniformCoverage={inputsByUniformCoverage}
                                    selectedCoverageTypeState={coverage?.name}
                                    isPreview={isPreview} 
                                />
                            )}
                            {isSalaryRank && (
                                <SalaryRank 
                                    inputsBySalaryRank={inputsBySalaryRank}
                                    selectedCoverageTypeState={coverage?.name}
                                    isPreview={isPreview} 
                                />
                            )}
                        </div>
                    </ViewSection>
                )}
                {/* ATTACHABLE RIDERS */}
                {isCustomize && (
                    <ViewSection
                        title="Attachable Riders"
                        description="Review all selected riders and their corresponding coverage."
                    >
                        <div className="overflow-x-auto">
                            <SelectedAttachableRiderTable 
                                isProductGCLI={isProductGCLI}
                                isSalaryRank={isSalaryRank}
                                isUniformCoverage={isUniformCoverage}
                                isLevelRankingAndSalaryRank={isLevelRankingAndSalaryRank}
                                selectedRiders={riders}
                                inputsBySalaryRank={inputsBySalaryRank}
                                inputsByLevelRanking={inputsByLevelRanking}

                                selectedCoverageTypeState={coverage}
                                selectedAmountOfLoansCheckBox={amountOfLoans}
                                inputsByUniformCoverage={inputsByUniformCoverage}

                                selectedBMSR={ridersBMSR}

                                isAmountOfLoan={isAmountOfLoansSelected}
                                amountOfLoansRiders={ridersAmountOfLoans}

                                selectUniformCoverageRidersState={ridersUniformCoverage}

                                selectLevelRankingRidersState={ridersLevelRanking}
                                selectSalaryRankRidersState={ridersSalaryRank}
                                isLevelRanking={isLevelRanking}

                                isPreview={isPreview}
                            />
                        </div>
                    </ViewSection>
                )}
                {/* BORROWERS + NOTES */}
                {isCustomize && (
                    <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
                        {/* Borrowers */}
                        <ViewSection
                            title="Eligibility Age and Benefit Amount"
                            description="Review the borrower information and configuration for this proposal."
                        >
                            <ClientInputForBorrowers
                                isProductGPA={isProductGPA}
                                isProductGCLI={isProductGCLI}
                                isProductGYRT={isProductGYRT}
                                isProductGCI={isProductGCI}
                                borrowerAgeOptionsList={borrowerAgeOptionsList}
                                minAge={minAgeProfile}
                                maxAge={maxAgeProfile}
                                isPreview={isPreview}
                            />
                        </ViewSection>
                        {/* Notes */}
                        <ViewSection
                            title="Notes & Remarks"
                            description="Review any additional remarks or notes included with this proposal."
                        >
                            <div className="min-h-[180px] rounded-lg border border-gray-200 bg-gray-50 p-4">
                                <div className="rich-text-viewer">
                                    {notesCFE ? (
                                        <div
                                            // className="ProseMirror break-words text-xs leading-5 text-gray-700"
                                            className="text-[13px]"
                                            dangerouslySetInnerHTML={{
                                                __html: notesCFE,
                                            }}
                                        />
                                    ) : (
                                        <p className="text-xs italic text-gray-400">
                                            No notes added.
                                        </p>
                                    )}
                                </div>
                            </div>
                        </ViewSection>
                    </div>
                )}
                {isCustomize && (
                    <ViewSection
                        title="Supporting Documents"
                        description="Review the documents attached to this proposal."
                    >
                        <ClientSupportingDocuments
                            files={filesCFE}
                            isPreview={isPreview}
                            handleDownloadFile={handleDownloadFileCFE}
                        />
                    </ViewSection>
                )}
            </div>
            {isLoadingDownloadMasterAttachedFile && (<LoadingFile/>)}
        </>
    )
}
